import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { publicAPI } from '../../services/api';

declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

const FacebookPixel: React.FC = () => {
  const location = useLocation();
  const [pixelId, setPixelId] = useState<string | null>(null);
  const [initialized, setInitialized] = useState(false);

  // Fetch active pixel ID on mount
  useEffect(() => {
    const fetchPixelId = async () => {
      // Check localStorage first for instant load
      const cachedId = localStorage.getItem('fb_pixel_id');
      if (cachedId) {
        setPixelId(cachedId);
      }

      try {
        const data = await publicAPI.getActiveFacebookPixel();
        if (data && data.pixel_id) {
          if (data.pixel_id !== cachedId) {
            setPixelId(data.pixel_id);
            localStorage.setItem('fb_pixel_id', data.pixel_id);
          }
        }
      } catch (error) {
        console.error('Failed to fetch Facebook Pixel ID:', error);
      }
    };
    fetchPixelId();
  }, []);

  // Initialize Pixel when ID is available
  useEffect(() => {
    if (!pixelId) return;

    if (!window.fbq) {
      // Inject Facebook Pixel Code with automatic config disabled
      // This prevents Facebook from auto-detecting button clicks as "SubscribedButton"
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        
        // Disable automatic button click detection to prevent "SubscribedButton" events
        fbq('set', 'autoConfig', false, '${pixelId}');
        fbq('init', '${pixelId}');
      `;
      document.head.appendChild(script);
      setInitialized(true);
    } else if (!initialized) {
      // If script already exists, disable autoConfig and init
      window.fbq('set', 'autoConfig', false, pixelId);
      window.fbq('init', pixelId);
      setInitialized(true);
    }
  }, [pixelId, initialized]);

  // Track PageView on route change
  useEffect(() => {
    if (initialized && window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location, initialized]);

  return null; // Component renders nothing
};

export default FacebookPixel;
